import { cn } from '@/utils/tailwind';

const PlanCardSubHeader: React.FC<
  React.HTMLAttributes<HTMLParagraphElement>
> = ({ children, className, ...props }) => (
  <p
    data-testid="PlanCardSubHeader"
    className={cn(
      'text-variant-body2 [&.success]:text-brand-green max-w-full min-w-0 overflow-hidden wrap-break-word text-ellipsis [&.bold]:font-bold [&.success]:font-bold',
      className,
    )}
    {...props}
  >
    {children}
  </p>
);

export default PlanCardSubHeader;
